
import debug from 'debug';
import {Base} from '../base-behaviour';

const log = debug('fus078/components/video-background');

export class videoBackground extends Base {

	static detectAspectRatio() {
		var windowWidth = $(window).width();
		var windowHeight = $(window).height();
		var width = 1280;
		var height = 720;
		var windowProportion = windowWidth / windowHeight;
		var origProportion = width / height;
		var proportion = windowHeight / height;

		if (windowProportion >= origProportion) {
			proportion = windowWidth / width;
		}

		return proportion;
	}

	constructor(element, options) {
		super(element, options);

		System.import(
			/* webpackMode: "lazy" */
			/* webpackChunkName: "vendor/jquery.backgroundvideo" */
			'@vendor/jquery.backgroundvideo'
		).then(this.init.bind(this));
		log('constructed', this.element);
	}

	init () {
		this.attach();
		$(window).resize(this.attach.bind(this));
	}

	setAspectRatio () {
		var aspectRatio = videoBackground.detectAspectRatio();
		var width = 1280;
		var height = 720;
		this.$element.find('video').width(aspectRatio * width);
		this.$element.find('video').height(aspectRatio * height);

		this.centerVideo();
	}

	centerVideo() {
		var centerX = (($(window).width() >> 1) - (this.$element.find('video').width() >> 1)) | 0;
		var centerY = (($(window).height() >> 1) - (this.$element.find('video').height() >> 1)) | 0;

		this.$element.find('video').css({ 'left': centerX });
	}

	attach () {

		var loop = this.$element.attr('data-loop-video');
		var autoplay = this.$element.attr('data-autoplay-video');
		var urlogv = this.$element.attr('data-video-ogv');
		var urlmp4 = this.$element.attr('data-video-mp4');
		var urlwebm = this.$element.attr('data-video-webm');
		var source = [];


		// If no touch specific vids selected load the desktop ones instead
		if (source.length == 0) {
			if (urlogv.length > 0) {
				source.push([urlogv, 'video/ogg']);
			}
			if (urlmp4.length > 0) {
				source.push([urlmp4, 'video/mp4']);
			}
			if (urlwebm.length > 0) {
				source.push([urlwebm, 'video/webm']);
			}
		}

		// Don't load video on mobile
		if (this.$element.is(':visible') && source.length > 0) {
			this.$element.find('#video-background-controls').show();
			this.$element.videobackground({
				videoSource: source,
				loop: loop == 'true',
				autoplay: autoplay == 'true',
				resize: false,
				muted: true,
				preload: 'none',
				controlPosition: '#video-background-controls > .column',
				controlText: ['', '', '', ''],
				loadedCallback () {
					$(this).addClass('loaded');
				}
			});
			this.setAspectRatio();
		}
		else {
			this.$element.find('#video-background-controls').hide();
		}
	}

}







// WEBPACK FOOTER //
// ./client/src/site__fus078/components/video-background/component.js